import React, { SyntheticEvent, useState } from 'react';
import { useSignupSmsMutation } from '~/features/Api/apiSlice';
import { InfluencerSmsForm } from '~/features/Influencer/InfluencerSmsForm';
import { InfluencerRegistration } from '~/features/Influencer/InfluencerRegistration';
import { useHistory } from 'react-router-dom';

const validPhoneRegEx = new RegExp('^[0-9]+$');
const optInText =
  'By entering your phone number, you agree to receive marketing messages at the number provided. Consent is not a condition of purchase. Message and data rates may apply. Message frequency varies. Reply STOP to cancel.';

export function InfluencerSmsSignup({
  influencerSlug,
  numRegistered,
  isStreamChosen,
  isGuest,
}: {
  influencerSlug: string;
  numRegistered: number;
  isStreamChosen: boolean;
  isGuest: boolean;
}) {
  const [showCheckYourTexts, setShowCheckYourTexts] = useState(false);
  const [showRegistrationForm, setShowRegistrationForm] = useState(false);
  const [phone, setPhone] = useState('+1 ');
  const cleanedPhone = phone.replace(/\W/g, '');
  const [signupApiCall, { isLoading, isError }] = useSignupSmsMutation();
  const history = useHistory();

  const isValid =
    cleanedPhone.match(validPhoneRegEx) && cleanedPhone.length === 11;

  const handleSubmit = async (e: SyntheticEvent) => {
    e.preventDefault();

    try {
      const response = await signupApiCall({
        phone: cleanedPhone,
        influencerSlug,
        optInText,
      }).unwrap();

      // Only show "Check Your Texts" if the SMS was sent
      setShowCheckYourTexts(!!response.sent_confirmation);

      if (isGuest) {
        setShowRegistrationForm(true);
      } else {
        history.push({
          pathname: window.location.pathname,
          search: '?registration-success',
        });
      }
    } catch (e) {
      // Further error handling comes from watching the isError flag above
      console.error(e);
    }
  };

  return (
    <div className={'mt-4'}>
      {showRegistrationForm ? (
        <InfluencerRegistration showCheckYourTexts={showCheckYourTexts} />
      ) : (
        <InfluencerSmsForm
          loading={isLoading}
          onSubmit={handleSubmit}
          value={phone}
          onChange={(e: SyntheticEvent<HTMLInputElement>) => {
            setPhone(e.currentTarget.value);
          }}
          error={isError}
          valid={isValid}
          numRegistered={numRegistered}
          isStreamChosen={isStreamChosen}
          optInText={optInText}
        />
      )}
    </div>
  );
}
